import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import moment from 'moment';
import DateSelector from './DateSelector';
import TempChart from './TempChart';
import TempComponent from './InputComponents/TempComponent';
import TempInputWithArrowsBoschHeatPump from './InputComponents/TempInputWithArrowsBoschHeatPump';
import TempInputWithArrowsThermiaHeatPump from './InputComponents/TempInputWithArrowsThermiaHeatPump';
import TempMeasurement from './InputComponents/TempMeasurement';
import GenericMeasurement from './InputComponents/GenericMeasurement';
import HeatPumpTargetSettings from './InputComponents/HeatPumpTargetSettings';
import ElspotReadOnlyValue from './InputComponents/ElspotReadOnlyValue';
import HeatingOnSwitch from './InputComponents/HeatingOnSwitch';
import WarmWaterBoschHeatPump from './InputComponents/WarmWaterBoschHeatPump';
import _ from 'lodash';
import ElConsumptionReadOnlyValue from './InputComponents/ElConsumptionReadOnlyValue';
import HeatingModeButtons from './InputComponents/HeatingModeButtons'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTint, faBatteryThreeQuarters } from '@fortawesome/free-solid-svg-icons';

const config = require('./config');
const dataPoints = [12, 19, 3, 5, 2, 3, 12, 19, 3, 5, 2, 3,12, 19, 3, 5, 2, 3, 12, 19, 3, 5, 2, 3];
const vatPercentage = 1.255;

function Dashboard() {
  const [curDate, setCurDate] = useState(new Date());
  const [selectedVillaHeatingMode, setSelectedVillaHeatingMode] = useState('');
  const [showSmedsbyTempSettings, setShowSmedsbyTempSettings] = useState(false);
  const [showVillaTempSettings, setShowVillaTempSettings] = useState(false);
  const [showSmedsbyHumidity, setShowSmedsbyHumidity] = useState(false);
  const [showVillaHumidity, setShowVillaHumidity] = useState(false);
  const [showSmedsbyBattery, setShowSmedsbyBattery] = useState(false);
  const [showVillaBattery, setShowVillaBattery] = useState(false);
  const [smedsbyHeatingValues, setSmedsbyHeatingValues] = useState([]);
  const [smedsbyThermiaHeatPumpValues, setSmedsbyThermiaHeatPumpValues] = useState({});
  const [villaHeatingValues, setVillaHeatingValues] = useState([]);
  const [elspotDataPoints, setElspotDataPoints] = useState([]);
  const [elspotNow, setElspotNow] = useState();
  const [elspotMin, setElspotMin] = useState();
  const [elspotMax, setElspotMax] = useState();
  const [elspotAvg, setElspotAvg] = useState();
  const [measurementsToShowInChart, setMeasurementsToShowInChart] = useState([]);
  const [villaHeatingPumpValues, setVillaHeatingPumpValues] = useState({});
  const [villaFloorHeatingUpValues, setVillaFloorHeatingUpValues] = useState({});
  const [villaFloorHeatingDownValues, setVillaFloorHeatingDownValues] = useState({});
  const [villaElectricityConsumption, setVillaElectricityConsumption] = useState({});
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const token = localStorage.getItem('token');

  const navigate = useNavigate();

  const toggleSmedsbyTempSettings = () => {
    setShowSmedsbyTempSettings(!showSmedsbyTempSettings);
  };
  const toggleVillaTempSettings = () => {
    setShowVillaTempSettings(!showVillaTempSettings);
  };

  const toggleSmedsbyHumidity = () => {
    setShowSmedsbyHumidity(!showSmedsbyHumidity);
  };
  const toggleVillaHumidity = () => {
    setShowVillaHumidity(!showVillaHumidity);
  };

  const toggleSmedsbyBattery = () => {
    setShowSmedsbyBattery(!showSmedsbyBattery);
  };
  const toggleVillaBattery = () => {
    setShowVillaBattery(!showVillaBattery);
  };

  if (shouldRedirect) {
    navigate('/login');
  }

  useEffect(() => {
    fetch(config.serverUrl + '/elspot?date=' + moment(curDate).format('YYYY-MM-DD'),  {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => {
      if (response.status === 401)
        setShouldRedirect(true);
      return response.json()
    })
    .then(data => {
      const curDateStart = moment(curDate).startOf('day');

      let values = [];
      if (data != null) {
        values = data.map((point, index) =>  {
          return {
            x: moment(curDateStart).add(index * 15, 'minutes').toDate(),
            y: point.value * vatPercentage
          };
        });
        
        const values2 = data.map(point =>  point.value * vatPercentage);
        const today = moment().startOf('day');

        if (moment(curDate).isSame(today, 'day')) {
          const now = new Date();
          const currentQuarter = (now.getHours() * 4) + Math.floor(now.getMinutes() / 15);
          setElspotNow(values2[currentQuarter] != null ? values2[currentQuarter].toFixed(2) : NaN.toString());
        }
        else
          setElspotNow(NaN.toString());

        setElspotAvg(_.mean(values2).toFixed(2));
        setElspotMin(Math.min(...values2).toFixed(2));
        setElspotMax(Math.max(...values2).toFixed(2));
      }
      else {
        setElspotNow(0);
        setElspotAvg(0);
        setElspotMin(0);
        setElspotMax(0);
      }

      setElspotDataPoints(values);
    })
   .catch(error => { console.log(error); });

   fetch(config.serverUrl + '/heating-target?env=smedsby&date=' + moment(curDate).format('YYYY-MM-DD'),  {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => response.json())
    .then(data => {
        const heatingValues = Array(24).fill({
          smedsbyHeatingOn: true,
          smedsbyTemperature: ""
        });

        if (data != null) {
          data.forEach(item => {
            const hour = moment.utc(item.time).local().hour();
            heatingValues[hour] = {
              smedsbyHeatingOn: item.smedsbyHeatingOn === true,
              smedsbyTemperature: item.smedsbyHeatingTemperature,
          }});
        }
  
        setSmedsbyHeatingValues(heatingValues);
      })
      .catch(error => { console.log(error); });
  
  fetch(config.serverUrl + '/heating-target?env=villa&date=' + moment(curDate).format('YYYY-MM-DD'),  {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(response => response.json())
  .then(data => {
      const heatingValues = Array(24).fill({
        villaTemperature: ""
      });

      if (data.constructor === Array) {
        data.forEach(item => {
          const hour = moment.utc(item.time).local().hour();
          heatingValues[hour] = {                
            villaTemperature: item.villaHeatingTemperature
        }});
      }

      setVillaHeatingValues(heatingValues);
    })
    .catch(error => { console.log(error); });
  }, [curDate, token]);  

  useEffect(() => {
    fetchVillaBoschHeatPumpValues();
  }, [token]);

  const fetchAllData = async () => {
    fetchVillaFloorHeatingUpValues();
    fetchVillaFloorHeatingDownValues();
    fetchVillaBoschHeatPumpValues();
    fetchSmedsbyThermiaHeatPumpValues();
    fetchVillaElectricityConsumption();
  }

  useEffect(() => {
    fetchAllData(); // Initial fetch
  
    const interval = setInterval(() => {
      fetchAllData();
    }, 30000); // Fetch every 30 seconds
  
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const fetchVillaBoschHeatPumpValues = () => {
    fetch(config.serverUrl + '/villa-bosch-heat-pump',  {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => response.json())
    .then(data => {
      setVillaHeatingPumpValues(data);
    });
  }

  const fetchSmedsbyThermiaHeatPumpValues = () => {
    fetch(config.serverUrl + '/smedsby-thermia-heat-pump',  {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => response.json())
    .then(data => {
      setSmedsbyThermiaHeatPumpValues(data);
    });
  }

  const fetchVillaFloorHeatingUpValues = () => {
    fetch(config.serverUrl + '/villa-heating-actuator?group=upstairs',  {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => response.json())
    .then(data => {
      setVillaFloorHeatingUpValues(data);
    });
  }

  const fetchVillaFloorHeatingDownValues = () => {
    fetch(config.serverUrl + '/villa-heating-actuator?group=downstairs',  {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => response.json())
    .then(data => {
      setVillaFloorHeatingDownValues(data);
    });
  }

  const fetchVillaElectricityConsumption = () => {
    fetch(config.serverUrl + '/villa-electricity-consumption?date=' + moment(curDate).format('YYYY-MM-DD'),  {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => response.json())
    .then(data => {
      setVillaElectricityConsumption(data);
    });
  }

  useEffect(() => {
    fetchVillaElectricityConsumption();
  }, [token, curDate]);

  useEffect(() => {
    fetchVillaFloorHeatingUpValues();
    fetchVillaFloorHeatingDownValues();
  }, [token]);  

  const postVillaFloorHeatingUpValue = (relay, value) => {
    fetch(config.serverUrl + '/villa-heating-actuator', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        group: 'upstairs',
        relay: relay,
        value: value
      })      
    })
    .then(setVillaFloorHeatingUpValues({ ...villaFloorHeatingUpValues, ['relay' + relay]: value }))
    .catch(error => { console.log(error); });
  }

  const postVillaFloorHeatingDownValue = (relay, value) => {
    fetch(config.serverUrl + '/villa-heating-actuator', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        group: 'downstairs',
        relay: relay,
        value: value
      })      
    })
    .then(setVillaFloorHeatingDownValues({ ...villaFloorHeatingDownValues, ['relay' + relay]: value }))
    .catch(error => { console.log(error); });
  }

  const handleCurDateChange = (curDate) => {
    setCurDate(curDate);
  };

  const addMeasurementToGraph = (header, measurement, showChartPoints, type) => {
    let newMeasurementsToShowInChart;
    if (measurementsToShowInChart.some(o => o.measurement === measurement)) {
      newMeasurementsToShowInChart = measurementsToShowInChart.filter(m => m.measurement !== measurement);
    } else {
      newMeasurementsToShowInChart = [...measurementsToShowInChart,
        {
            header: header,
            measurement: measurement,
            showChartPoints: showChartPoints,
            type: type
        }];
    }
    setMeasurementsToShowInChart(newMeasurementsToShowInChart);
    //localStorage.setItem('measurementsToShowInChart', JSON.stringify(newMeasurementsToShowInChart));
  };

  return (    
    <div className="App">
      <header className="App-header">
        <div>
          <DateSelector curDate={curDate} onCurDateChange={handleCurDateChange.bind(this)}/>
        </div>
        <div className="temp-chart-div"> 
          <TempChart
            curDate={curDate}
            elspotDataPoints={elspotDataPoints}
            measurementsToShowInChart={measurementsToShowInChart}/>
        </div>
        <div className="temp-components-parent-div">
          <div className="temp-components-div" style={{ display: 'flex', justifyContent: 'space-between' }}>
            {dataPoints.map((dataPoint, index) => (
              <TempComponent key={index} index={index} data={dataPoint} curDate={curDate} smedsbyHeatingValues={smedsbyHeatingValues[index]} villaHeatingValues={villaHeatingValues[index]} />
            ))}
          </div>
        </div>        
        <div className="temp-input-fieldset-parent-div">
          <fieldset className="temp-input-fieldset">
            <legend>Elspot (c/kWh)</legend>
            <ElspotReadOnlyValue header="Now" inputValue={elspotNow}/>
            <ElspotReadOnlyValue header="Max" inputValue={elspotMax}/>
            <ElspotReadOnlyValue header="Avg" inputValue={elspotAvg}/>
            <ElspotReadOnlyValue header="Min" inputValue={elspotMin}/>
          </fieldset>
          <fieldset className="temp-input-fieldset">
            <legend>Smedsby</legend>
            <div className="heating-mode-container" style={{ textAlign: 'right' }}>
              <button onClick={toggleSmedsbyHumidity} className={showSmedsbyHumidity ? 'settings-button-selected' : 'settings-button'}>
                <FontAwesomeIcon icon={faTint} />
              </button>
              <button onClick={toggleSmedsbyBattery} className={showSmedsbyBattery ? 'settings-button-selected' : 'settings-button'}>
                <FontAwesomeIcon icon={faBatteryThreeQuarters} />
              </button>
              <button onClick={toggleSmedsbyTempSettings} className={showSmedsbyTempSettings ? 'settings-button-selected' : 'settings-button'}>
                <FontAwesomeIcon icon={faCog} />
              </button>
            </div>
            <HeatPumpTargetSettings header="Heat pump target (C°)" selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showSmedsbyTempSettings}/>
            <TempInputWithArrowsThermiaHeatPump header="Heat Pump" inputValue={smedsbyThermiaHeatPumpValues.Target}/>
            {/*<TempInputWithArrowsMqtt header="Heat Pump" measurement="SmedsbyHeatingTemp" mqtt="home/adjustTemp"/>*/}
            <HeatingOnSwitch header="Heating On" measurement="SmedsbyHeatingOn" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} heatingOn={smedsbyThermiaHeatPumpValues.HeatingOn}/>
            <TempMeasurement header="Bedroom" measurement="Sensor3" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} zwaveThermostatId="004" selectedHeatingMode='Home' showTempSettings={showSmedsbyTempSettings} showHumidity={showSmedsbyHumidity} showBattery={showSmedsbyBattery}/>
            <TempMeasurement header="Hobby Room (C°)" measurement="Sensor4" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} zwaveThermostatId="007" selectedHeatingMode='Home' showTempSettings={showSmedsbyTempSettings} showHumidity={showSmedsbyHumidity} showBattery={showSmedsbyBattery}/>
            <TempMeasurement header="Kitchen (C°)" measurement="Sensor9" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} zwaveThermostatId="003" selectedHeatingMode='Home' showTempSettings={showSmedsbyTempSettings} showHumidity={showSmedsbyHumidity} showBattery={showSmedsbyBattery}/>
            <TempMeasurement header="Lucas Room (C°)" measurement="Sensor14" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} zwaveThermostatId="002" selectedHeatingMode='Home' showTempSettings={showSmedsbyTempSettings} showHumidity={showSmedsbyHumidity} showBattery={showSmedsbyBattery}/>
            <TempMeasurement header="Sauna/TV Room (C°)" measurement="Sensor10" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} zwaveThermostatId="005" selectedHeatingMode='Home' showTempSettings={showSmedsbyTempSettings} showHumidity={showSmedsbyHumidity} showBattery={showSmedsbyBattery}/>
            <GenericMeasurement header="Outdoor temp (C°)" measurement="SmedsbyHeatingPumpOutdoorTemp" inputValue={smedsbyThermiaHeatPumpValues.T_UTE}/>
          </fieldset>
          <fieldset className="temp-input-fieldset">
            <legend>Villa</legend>
            <div className="heating-mode-container">
              <HeatingModeButtons selectedMode={selectedVillaHeatingMode} setSelectedMode={setSelectedVillaHeatingMode} />
              
              <button onClick={toggleVillaHumidity} className={showVillaHumidity ? 'settings-button-selected' : 'settings-button'}>
                <FontAwesomeIcon icon={faTint} />
              </button>
              <button onClick={toggleVillaBattery} className={showVillaBattery ? 'settings-button-selected' : 'settings-button'}>
                <FontAwesomeIcon icon={faBatteryThreeQuarters} />
              </button>
              <button onClick={toggleVillaTempSettings} className={showVillaTempSettings ? 'settings-button-selected' : 'settings-button'}>
                <FontAwesomeIcon icon={faCog} />
              </button>
            </div>
            <HeatPumpTargetSettings header="Heat pump target (C°)" selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings}/>
            {/* <TempMeasurement header="Kitchen (C°)" measurement="FSensor4" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/> */}
            <TempMeasurement header="Upstairs red room (C°)" measurement="FSensor7" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} floorHeatingRelayValue={villaFloorHeatingUpValues.relay1} setVillaFloorHeatingValue={(value) => postVillaFloorHeatingUpValue(1, value)} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/>
            <TempMeasurement header="Upstairs middle room (C°)" measurement="FSensor8" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} floorHeatingRelayValue={villaFloorHeatingUpValues.relay2} setVillaFloorHeatingValue={(value) => postVillaFloorHeatingUpValue(2, value)} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/>
            <TempMeasurement header="Upstairs yellow room (C°)" measurement="FSensor10" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/>
            {/* <TempMeasurement header="Living room (C°)" measurement="FSensor7" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/> */}
            <TempMeasurement header="Cellar (C°)" measurement="FSensor5" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/>
            <TempMeasurement header="Bath room (C°)" measurement="FSensor3" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} floorHeatingRelayValue={villaFloorHeatingDownValues.relay2} setVillaFloorHeatingValue={(value) => postVillaFloorHeatingDownValue(2, value)} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/>
            <TempMeasurement header="Guest room (C°)" measurement="FSensor12" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} floorHeatingRelayValue={villaFloorHeatingDownValues.relay4} setVillaFloorHeatingValue={(value) => postVillaFloorHeatingDownValue(4, value)} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/>
            {/* <TempMeasurement header="TV room (C°)" measurement="FSensor12" addMeasurementToGraph={addMeasurementToGraph} measurementsToShowInChart={measurementsToShowInChart} selectedHeatingMode={selectedVillaHeatingMode} showTempSettings={showVillaTempSettings} showHumidity={showVillaHumidity} showBattery={showVillaBattery}/> */}
          </fieldset>
          <fieldset className="temp-input-fieldset">
            <legend>Villa heat pump</legend>
             <TempInputWithArrowsBoschHeatPump header="Heat Pump" inputValue={villaHeatingPumpValues.targetTemp}/>
             <GenericMeasurement header="Radiator forward temp (C°)" measurement="VillaHeatingPumpForwardTemp" showChartPoints={false} addMeasurementToGraph={addMeasurementToGraph} inputValue={villaHeatingPumpValues.radiatorForwardTemp}/>
             <GenericMeasurement header="Heat carrier return temp (C°)" measurement="VillaHeatingPumpReturnTemp" showChartPoints={false} addMeasurementToGraph={addMeasurementToGraph} inputValue={villaHeatingPumpValues.heatCarrierReturnTemp}/>
             <GenericMeasurement header="Compressor speed (%)" measurement="VillaHeatingPumpCompressorSpeed" showChartPoints={false} addMeasurementToGraph={addMeasurementToGraph} inputValue={villaHeatingPumpValues.compressorSpeed}/>
             <GenericMeasurement header="Warm water temp (C°)" measurement="VillaHeatingPumpWarmWaterTemp" showChartPoints={false} addMeasurementToGraph={addMeasurementToGraph} inputValue={villaHeatingPumpValues.warmWaterTemp}/>
             <GenericMeasurement header="Outdoor temp (C°)" measurement="VillaHeatingPumpOutdoorTemp" showChartPoints={false} addMeasurementToGraph={addMeasurementToGraph} inputValue={villaHeatingPumpValues.outdoorTemp}/>
             <WarmWaterBoschHeatPump header="Warm water program" measurement="VillaHeatingPumpWarmWaterProgram" addMeasurementToGraph={addMeasurementToGraph} inputValue={villaHeatingPumpValues.warmWaterProgram}/>
             {/* <TempMeasurement header="Power consumption (kW)" measurement="VillaHeatingPumpPowerConsumption" addMeasurementToGraph={addMeasurementToGraph} inputValue={villaHeatingPumpValues.powerConsumption}/> */}
          </fieldset>
          <fieldset className="temp-input-fieldset">
            <legend>Villa electricity consumption</legend>
             <ElConsumptionReadOnlyValue header="Total power (kWh)" measurement="electricityconsumption.total_power_import_kwh" addMeasurementToGraph={addMeasurementToGraph} inputValue={villaElectricityConsumption.total_power_import_kwh}/>
             <ElConsumptionReadOnlyValue header="Power last hour (Wh)" inputValue={villaElectricityConsumption.last_hour_kwh * 1000}/>
             <ElConsumptionReadOnlyValue header="Price with average power (c/h)" inputValue={villaElectricityConsumption.last_hour_kwh * elspotNow}/>
             <ElConsumptionReadOnlyValue header="Power average/h (Wh)" inputValue={villaElectricityConsumption.day_kwh * 1000 / 24}/>
             <ElConsumptionReadOnlyValue header="Power last day (kWh)" inputValue={villaElectricityConsumption.day_kwh}/>
             <ElConsumptionReadOnlyValue header="Active power tot (W)" measurement="electricityconsumption.active_power_w" addMeasurementToGraph={addMeasurementToGraph} inputValue={villaElectricityConsumption.active_power_w}/>
             <ElConsumptionReadOnlyValue header="Active power L1 (W)" measurement="electricityconsumption.active_power_l1_w" addMeasurementToGraph={addMeasurementToGraph} inputValue={villaElectricityConsumption.active_power_l1_w}/>
             <ElConsumptionReadOnlyValue header="Active power L2 (W)" measurement="electricityconsumption.active_power_l2_w" addMeasurementToGraph={addMeasurementToGraph} inputValue={villaElectricityConsumption.active_power_l2_w}/>
             <ElConsumptionReadOnlyValue header="Active power L3 (W)" measurement="electricityconsumption.active_power_l3_w" addMeasurementToGraph={addMeasurementToGraph} inputValue={villaElectricityConsumption.active_power_l3_w}/>
          </fieldset>
        </div>
      </header>
    </div>
  );
}

export default Dashboard;
